import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/app/bridge-irl-application/components/BridgeIRLContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/app/bridge-irl-application/components/BridgeIRLHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/components/JourneyNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/components/NextBridgeCTA.tsx");
